/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useRef, useEffect } from 'react'
import { useGLTF, useAnimations } from '@react-three/drei'

export default function Model(props) {
  const group = useRef()
  const { nodes, materials, animations } = useGLTF('assets/glb-file/47.glb')
  const { actions } = useAnimations(animations, group)

  useEffect(() => {
    //actions['flight_path_3'].play();
    //actions['flight_path_2'].play();
    //actions['flight_path_1'].play();
    actions['idle'].play();
  });

  return (
    <group ref={group} {...props} dispose={null}>
      <group>
        <group name="RootNode0" scale={0.1}>
          <group name="geo1">
            <skinnedMesh name="aerobatic_plane2" geometry={nodes.aerobatic_plane2.geometry} material={nodes.aerobatic_plane2.material} skeleton={nodes.aerobatic_plane2.skeleton} />
          </group>
          <group name="skeletal3">
            <primitive object={nodes.root4} />
          </group>
        </group>
      </group>
    </group>
  )
}

//useGLTF.preload('assets/glb-file/47.glb')
